import styled from "styled-components"

import {Select} from "@irati/ui/src/FormItem"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {greys} from "@irati/ui/src/global/colors"

export default styled(Select)`
  margin: 0;

  .col-xs-12 {
    padding: 0;
  }

  .Select {
    & > .Select-control {
      height: 40px;
      border: 1px solid ${greys.light} !important;

      & .Select-value {
        width: 100%;
        padding-left: 20px;
      }

      & .Select-clear-zone {
        right: 5px;
      }

      ${minWidthMedia.tablet`
        height: 60px;
      `}
    }

    .Select-placeholder, div.Select-input, .Select-value-label {
      line-height: 41px;

      ${minWidthMedia.tablet`
        line-height: 60px;
      `}
    }

    div.Select-input {
      width: 100%;
      padding-left: 42px;
    }

    .is-focused {
      background-color: ${greys.light};
    }

    .Select-option {
      padding-left: 20px;
      &:hover {
        background-color: ${greys.light};
      }
      &:first-of-type {
        border-bottom: 1px solid ${greys.light};
      }
    }
  }
`
